// extracted by mini-css-extract-plugin
export default {"root":"FDht9BCyV0","row":"eiep0F9T_l"};